import '@fontsource/barlow-condensed/100.css';
import '@fontsource/barlow-condensed/200.css';
import '@fontsource/barlow-condensed/300.css';
import '@fontsource/barlow-condensed/400.css';

import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';

import '@fontsource/raleway/100.css';
import '@fontsource/raleway/200.css';

import './index.css'
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import App from './App';
import baseTheme from './styles/themes/baseTheme';
import './config/i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider theme={baseTheme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
